module.exports = __webpack_public_path__ + "media/12_12.7c6bc8eb.wav";